import * as React from "react"

interface ActionPlanIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  fill?: string;
}

export function ActionPlanIcon({width = 24, height = 24, fill = '#262626', ...props}: Readonly<ActionPlanIconProps>): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            {...props}
        >
            <g fill={fill} clipPath="url(#a)">
            <path
                fillRule="evenodd"
                d="M19.247 4.334H14.26c0-.736-.59-1.334-1.318-1.334H11.06c-.727 0-1.318.598-1.318 1.334H4.753A.757.757 0 0 0 4 5.097v15.136c0 .422.332.763.748.763 0 0 3.56.01 5.84 0 3.382-.015 8.66 0 8.66 0 .415 0 .752-.341.752-.763V5.097a.757.757 0 0 0-.753-.763Zm-8 1.525H9.553v1.144h4.894V5.86h-1.694V4.525h-1.506V5.86ZM18.5 19.5V5.86h-2.547V8.3H8.047V5.86H5.5V19.5h13Z"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M9.666 10.052a.35.35 0 0 1 .026.495l-.594.681-.388.431-.002.001s-.078.094-.193.125a.356.356 0 0 1-.23-.015.38.38 0 0 1-.119-.078 1.322 1.322 0 0 1-.07-.07 16.259 16.259 0 0 1-.293-.326l-.046-.053-.013-.014-.004-.006a.35.35 0 0 1 .532-.454l.004.005.013.014.043.05.077.089.763-.848a.35.35 0 0 1 .494-.027ZM9.666 13.052a.35.35 0 0 1 .026.495l-.594.681-.388.431-.002.001s-.078.094-.193.125a.356.356 0 0 1-.23-.015.38.38 0 0 1-.119-.078 1.322 1.322 0 0 1-.07-.07 16.259 16.259 0 0 1-.293-.326l-.046-.053-.013-.014-.004-.006a.35.35 0 0 1 .532-.454l.004.005.013.014.043.05.077.089.763-.848a.35.35 0 0 1 .494-.027ZM9.666 16.052a.35.35 0 0 1 .026.495l-.594.681-.388.431-.002.001s-.078.094-.193.125a.356.356 0 0 1-.23-.015.38.38 0 0 1-.119-.078 1.322 1.322 0 0 1-.07-.07 16.259 16.259 0 0 1-.293-.327l-.046-.052-.013-.014-.004-.006a.35.35 0 0 1 .532-.454l.004.005.013.014.043.05.077.089.763-.849a.35.35 0 0 1 .494-.026Z"
                clipRule="evenodd"
            />
            <path d="M10.7 10.7c0-.11.09-.2.2-.2h5.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2h-5.6a.2.2 0 0 1-.2-.2v-.6ZM10.7 13.7c0-.11.09-.2.2-.2h5.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2h-5.6a.2.2 0 0 1-.2-.2v-.6ZM10.7 16.7c0-.11.09-.2.2-.2h5.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2h-5.6a.2.2 0 0 1-.2-.2v-.6Z" />
            </g>
            <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
            </defs>
        </svg>
    )
}
